import React from 'react';
//import PropTypes from 'prop-types';
//import { isEmpty } from '../helpers';
import AdminEditOrgPage from './AdminEditOrgPage';
//import AdminManageUsersPage from './AdminManageUsersPage';
import isPage from '../hoc/isPage';
import hasData from '../hoc/hasData';
import { AppContext } from '../context/AppContext';
import Header from '../components/Header';
import Tabs from '../components/Tabs';
import Tab from '../components/Tab';
import GridContainer, { GridContainerToolbar, GridContainerToolbarOption } from '../components/GridContainer';
import config from '../config/config';
import { BlankCell, ButtonCell, DropDownFilterCell, BooleanCell } from "../components/utils/GridHelpers";
//import { Button } from '@progress/kendo-react-buttons';
import { Dialog } from "@progress/kendo-react-dialogs";
import { GridColumn as Column } from "@progress/kendo-react-grid";
import { Redirect } from 'react-router-dom';
import LoginContainer from '../components/LoginContainer';
import { compose } from 'redux';
import localize from '../hoc/localize';
const uuidv4 = require('uuid/v4');

class ChildOrgGrid extends React.Component {

    countries;
    orgTypes;

    constructor(props) {
        super(props);

        const data = props.dataItem.details;

        this.state = { data }



        // get a unique list of countries 
        this.countries = Array.from(new Set(data.filter(d => d.country).map(d => d.country)));


        // get a unique list of org types
        this.orgTypes = Array.from(new Set(data.filter(d => d.orgType).map(d => d.orgType)));
    }

    expandChange = (event) => {

        // if closing the child row, then just re-render the UI to reflect this
        if (!event.value) {
            event.dataItem.expanded = false;
            this.forceUpdate();
            return;
        }

        // check if we have already expanded this row
        if (event.dataItem.details !== undefined) {
            event.dataItem.expanded = event.value;
            this.forceUpdate();
            return;
        }

        // what orgID is this row?
        let orgID = event.dataItem.orgID;

        // take a shallow copy of the data at hand
        let data = this.state.data.slice();

        // find what index we're on
        let index = data.findIndex(data => data.orgID === orgID);

        // load up the child dealerships
        this.props.getData(`/api/portal/admin/org/${orgID}/GetChildOrgList`)
            .then(response => {
                event.dataItem.expanded = event.value;
                data[index].details = response.data;
                this.forceUpdate();
            })
            .catch(error => {
                // data[index].details = [];
                // this.forceUpdate();
                this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0101"))
            });
    }

    rowRender = (row, props) => {
        let newRow = row;

        // check if the org has any children; if not, then hide the expander button
        if (!props.dataItem.hasChildren) {

            newRow.props.children[0] = (<td key={uuidv4()}></td>)
        }
        return newRow
    }
    render() {

        // get array of data

        const data = this.props.dataItem.details;

        if (data) {
            return (
                <div className="detail-grid">
                    <GridContainer
                        data={data}
                        sortColumn="orgName"
                        filterable
                        detail={WrappedChildOrgGrid}
                        rowRender={this.rowRender}
                        onExpandChange={this.expandChange}
                    >

                        <Column
                            width="300px"
                            field="orgName"
                            title={this.props.returnLocalizedString("m0102")} />
                        <Column
                            width="250px"
                            field="orgType"
                            title={this.props.returnLocalizedString("m0103")}
                            filterCell={(props) => <DropDownFilterCell data={this.orgTypes}  {...props} />} />
                        <Column
                            width="250px"
                            field="country"
                            title={this.props.returnLocalizedString("m0104")}
                            filterCell={(props) => <DropDownFilterCell data={this.countries}  {...props} />} />
                        <Column
                            width="150px"
                            field="inactive"
                            title={this.props.returnLocalizedString("m0095")}
                            filter="boolean"
                            cell={(props) =>
                                <BooleanCell {...props} />
                            } />
                        <Column
                            filterable={false}
                            resizable={false}
                            sortable={false}
                            reorderable={false}
                            cell={(props) => (
                                <BlankCell {...props} />
                            )}
                            editable={false}
                        />
                    </GridContainer>
                </div>
            )
        }
        else {
            return (
                <div className="detail-grid">
                    {this.props.returnLocalizedString("m0105")}
                </div>
            )
        }
    }
}

const WrappedChildOrgGrid = compose(localize, hasData)(ChildOrgGrid);

class AdminPage extends React.Component {
    countries; // unique array of countries
    orgTypes; // unique array of org types

    state = {
        data: null,
        showDialog: false,
        selectedOrg: null,
        loginToOrgID: null, // orgID that the user wants to log into
        loggedIntoOtherOrg: false, // user decided to log into another org
        goToManageOrgUsers: false,
        goToManageSuperAdmins: false,
        performingLogin: false
    }
    componentWillUnmount() {
        clearInterval(this.timer);
    }
    componentDidMount() {
        // fetch list of orgs
        this.getData();

    }

    // fetch list of orgs
    getData = () => {
        let apiUrl = "/api/portal/admin/org/GetList";
        this.props.getData(apiUrl).then(({ data }) => {

            // get unique list of org types and countries
            this.orgTypes = Array.from(new Set(data.filter(d => d.orgType).map(d => d.orgType)));

            // filter out null countries
            this.countries = Array.from(new Set(data.filter(d => d.country).map(d => d.country)));

            //console.log(this.orgTypes, this.countries);

            //debugger;

            this.setState({ data })
        }).catch(error => {
            this.props.alert("error", this.props.returnLocalizedString('m0023'), this.props.returnLocalizedString('m0106'))
        })
    }
    expandChange = (event) => {

        // user wants to close the row
        if (!event.value) {
            event.dataItem.expanded = false;
            this.forceUpdate();
            return;
        }

        // if we have already expanded this row, then no need to do any more data fetching
        if (event.dataItem.details !== undefined) {
            event.dataItem.expanded = event.value;
            this.forceUpdate();
            return;
        }

        // what orgID is this row?
        let orgID = event.dataItem.orgID;

        // load up the child dealerships

        // this holds array of objects, each representing an Org
        //let details = []

        // get a copy of the state data
        let data = this.state.data.slice();

        // find what row index we're on
        let index = data.findIndex(data => data.orgID === orgID);

        this.props.getData(`/api/portal/admin/org/${orgID}/GetChildOrgList`)
            .then((response) => {
                event.dataItem.expanded = event.value;
                data[index].details = response.data;
                this.forceUpdate();
            })
            .catch(error => {
                //event.dataItem.expanded = event.value;
                //data[index].details = [];
                //this.forceUpdate();
                this.props.alert("error", this.props.returnLocalizedString('m0023'), this.props.returnLocalizedString('m0101'))
            })

    }
    rowRender = (row, props) => {
        let newRow = row;

        // check if the org has any children; if not, then hide the expander button
        if (!props.dataItem.hasChildren) {
            newRow.props.children[0] = (<td key={uuidv4()}></td>);


        }
        return newRow

    }
    handleAddOrgClick = (e) => {
        this.setState({
            showDialog: true
        });
    }
    handleEditClick = (e, props) => {

        // get info for the org that we selected
        const { orgID, orgName } = props.dataItem

        // bring up the dialog
        this.setState({
            showDialog: true,
            selectedOrg: { orgID, orgName }
        })
    }
    handleLoginClick = (e, props) => {
        // handle login
        const { orgID, orgName } = props.dataItem;


        this.props.postData('/api/portal/admin/org/LoginToOrg', {
            userID: '12E5A0D2-C1CE-4680-9287-E8213F2E2A06',
            orgID
        })
            .then(() => {
                this.props.alert('info', this.props.returnLocalizedString("m0072"), this.props.returnLocalizedString("m0107", "", orgName))
                this.props.saveToSessionStorage("selectedReportOrg", null);
                this.setState({
                    performingLogin: true
                });

            })
            .catch(error => {
                this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0108", "", orgName))
                return;
            })
    }

    handleCloseModal = () => {

        this.setState({
            showDialog: false,
            selectedOrg: null
        });
    }

    handleManageUsersClick = (e, props) => {
        // need to rename this to orgID once Victor/Sergei make the fixes
        const { orgID, orgName } = props.dataItem;
        this.setState({
            selectedOrg: { orgID, orgName },
            goToManageOrgUsers: true
        });
    }

    // user wants to look at list of super admins
    handleManageSuperAdminsClick = (e) => {
        this.setState({
            goToManageSuperAdmins: true
        })
    }

    handleRefreshListing = () => {
        // refresh the list of orgs
        this.getData();

    }
    onDataLoaded = () => {
        this.setState({
            isPending: false
        });
    }
    onFail = () => {
        this.setState({
            isPending: false
        })
    }
    onLoginFail = () => {
        this.setState({
            performingLogin: false
        }, () => {
            this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0109"))
        })
    }
    render() {


        if (this.state.goToManageOrgUsers) {
            const { selectedOrg } = this.state;

            return <Redirect to={`/admin/org/${selectedOrg.orgID}/users?orgName=${selectedOrg.orgName}`} />
        }
        if (this.state.goToManageSuperAdmins) {
            // get the roleID for superadmins

            const superAdminRole = config.roles.find(role => role.role === "superadmin");
            return <Redirect to={`/admin/org/users?roleID=${superAdminRole.roleID}&role=${superAdminRole.role}`} />
        }

        // if performing login, then render the LoginContainer
        // then ... on success, redirect to dashboard
        // else ... just reload the current page and show the error

        if (this.state.performingLogin) {
            return <LoginContainer forceResetProps={true} onFail={this.onLoginFail} />
        }

        const tabs = (<Tabs>
            <Tab label={this.props.returnLocalizedString("m0004")} link="/dashboard" ></Tab>
            <Tab label={this.props.returnLocalizedString("m0090")} ></Tab>
        </Tabs>);

        //!DBTRANS! @m0004@ Home !DEVNOTE! Button label
        //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status 
        //!DBTRANS! @m0048@ Org Code !DEVNOTE! Action status Button label
        //!DBTRANS! @m0072@ Heads up! !DEVNOTE! Button label
        //!DBTRANS! @m0089@ Manage Users !DEVNOTE! Button label
        //!DBTRANS! @m0090@ Manage Orgs !DEVNOTE! Button label
        //!DBTRANS! @m0095@ Inactive !DEVNOTE! Field name
        //!DBTRANS! @m0101@ Unable to bring up the list of child orgs. Please try again. !DEVNOTE! Action status Reason
        //!DBTRANS! @m0102@ Org Name !DEVNOTE! Field name
        //!DBTRANS! @m0103@ Org Type !DEVNOTE! Field name
        //!DBTRANS! @m0104@ Country !DEVNOTE! Field name
        //!DBTRANS! @m0105@ No data to show here! !DEVNOTE! Missing data 
        //!DBTRANS! @m0106@ Unable to get the list of orgs. Please try again. !DEVNOTE! Action status reason
        //!DBTRANS! @m0107@ Attempting to log you into %var1% ... !DEVNOTE! Action status
        //!DBTRANS! @m0108@ Unable to log you into %var1%. Please try again. !DEVNOTE! Action status reason
        //!DBTRANS! @m0109@ Unable to log you into the org. Please try again. !DEVNOTE! Action status reason
        //!DBTRANS! @m0110@ Create new org !DEVNOTE! Button label
        //!DBTRANS! @m0111@ Edit !DEVNOTE! Option label
        //!DBTRANS! @m0112@ Log in to this org !DEVNOTE! Option label

        return (

            <React.Fragment>
                <Header title={this.props.returnLocalizedString("m0090")} tabs={tabs} />
                <section className="page-content-padding-top-70 grid-row pad-it admin">

                    {/* <Button className="k-button k-primary" title="Create or update all users who are super admins." onClick={this.handleManageSuperAdminsClick}>Manage Super Admins</Button> */}


                    <GridContainer
                        data={this.state.data}
                        sortColumn="orgName"
                        detail={WrappedChildOrgGrid}
                        rowRender={this.rowRender}
                        onExpandChange={this.expandChange}
                        filterable
                        pageable={true}
                        pageSizes={[5, 10, 20]}
                        pageSize={10}

                    >
                        <GridContainerToolbar>
                            <GridContainerToolbarOption type="add" tooltip="m0110" primary={true} handleClick={this.handleAddOrgClick} />
                        </GridContainerToolbar>

                        <Column
                            title={this.props.returnLocalizedString("m0102")}
                            field="orgName"
                            width="175px"
                        />
                        <Column
                            title={this.props.returnLocalizedString("m0103")}
                            field="orgType"
                            width="180px"
                            filterCell={(props) => <DropDownFilterCell data={this.orgTypes}  {...props} />}
                        />
                        <Column
                            title={this.props.returnLocalizedString("m0104")}
                            field="country"
                            width="105px"
                            filterCell={(props) => <DropDownFilterCell data={this.countries}  {...props} />}
                        />
                        <Column
                            title={this.props.returnLocalizedString("m0048")}
                            field="orgCode"
                            width="170px"

                        />
                        <Column width="90px" field="inactive" title={this.props.returnLocalizedString("m0095")} filter="boolean" cell={(props) =>
                            <BooleanCell {...props} />
                        } />
                        <Column
                            filterable={false}
                            sortable={false}
                            reorderable={false}
                            width= {`${this.props.returnLocalizedString("m0111").length * 8 + 36}px`}
                            cell={(props) => (
                                <ButtonCell handleClick={(e) => { this.handleEditClick(e, props) }} text={this.props.returnLocalizedString("m0111")} {...props} />
                            )}
                            editable={false}
                        />
                        <Column
                            filterable={false}
                            sortable={false}
                            reorderable={false}
                            width={`${this.props.returnLocalizedString("m0089").length * 8 + 36}px`}
                            cell={(props) => (
                                <ButtonCell handleClick={(e) => { this.handleManageUsersClick(e, props) }} text={this.props.returnLocalizedString("m0089")} {...props} />
                            )}
                            editable={false}
                        />
                        <Column
                            filterable={false}
                            sortable={false}
                            reorderable={false}
                            width={`${this.props.returnLocalizedString("m0112").length * 8 + 36}px`}
                            cell={(props) => (
                                <ButtonCell handleClick={(e) => { this.handleLoginClick(e, props) }} text={this.props.returnLocalizedString("m0112")} {...props} />
                            )}
                            editable={false}
                        />
                        <Column
                            filterable={false}
                            resizable={false}
                            sortable={false}
                            reorderable={false}
                            cell={(props) => (
                                <BlankCell {...props} />
                            )}
                            editable={false}
                        />
                    </GridContainer>
                </section>

                {this.state.showDialog && (
                    <Dialog
                        height={"87.5%"}
                        width={"75%"}
                        minWidth={320}
                        closeIcon={false}
                    >
                        <AdminEditOrgPage
                            handleCloseModal={this.handleCloseModal}
                            handleRefreshListing={this.handleRefreshListing}
                            org={this.state.selectedOrg} />
                    </Dialog>)
                }
            </React.Fragment>
        )
    }
}
AdminPage.contextType = AppContext;
export default isPage(AdminPage)


// WEBPACK FOOTER //
// ./src/containers/AdminPage.js